enum SubscriptionInterval {
  MONTHLY = "monthly",
  ANNUAL = "annual",
}

export default SubscriptionInterval;
